import { store } from "../reducer/Store";
import Select from "react-select";
import React from "react";

const SelectYears = ({ year, setYear }) => {
  const { dispatch, state } = React.useContext(store);
  return (
    <Select
      placeholder="Années"
      required
      isMulti={false}
      value={year}
      onChange={(e) => {
        setYear(e);
        localStorage.setItem("currentYear", JSON.stringify(e));
        dispatch({
          type: "SET_CURRENTYEAR",
          payload: e,
        });
      }}
      name="years"
      options={state.listYears}
      className="bg-blue-light black border-white"
    />
  );
};

export default SelectYears;
